import script from "./sub-device-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./sub-device-table.vue?vue&type=script&lang=ts&setup=true"

import "./sub-device-table.vue?vue&type=style&index=0&id=4c1c8a50&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1c8a50"]])

export default __exports__